import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { QuotesRepository } from '../../shared/repositories/quotes.repository';
import { BillsRepository } from '../../shared/repositories/bills.repository';
import { BookOfBusinessService } from '../../shared/services/book-of-business.service';
import { getHttpParams } from '../../shared/utils/create-http-params';
import { take } from 'rxjs';

interface DashboardTile {
  id: string;
  title: string;
  description: string;
  icon: string;
  href: string;
}

interface QuickStat {
  value: string;
  label: string;
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [MatCardModule, MatButtonModule, MatIconModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  tiles: DashboardTile[] = [
    {
      id: 'quotes',
      title: 'Quotes',
      description: 'Access and manage client quotes',
      icon: 'description',
      href: '/quotes-dashboard',
    },
    {
      id: 'book',
      title: 'Book of Business',
      description: 'View your entire portfolio',
      icon: 'menu_book',
      href: '/book',
    },
    // {
    //   id: 'commissions',
    //   title: 'Commissions',
    //   description: 'Track earnings and payments',
    //   icon: 'attach_money',
    //   href: '/quotes-dashboard',
    // },
    {
      id: 'groups',
      title: 'Flex Group',
      description: 'Create and Manage Group List Bill Accounts',
      icon: 'group',
      href: '/bills-dashboard',
    },
  ];

  agentModeLink = '';

  stats: QuickStat[] = [
    { value: '—', label: 'Quotes YTD' },
    { value: '—', label: 'Total Active Clients' },
    // { value: '—', label: 'YTD Commissions' },
    { value: '—', label: 'Groups Managed' },
  ];

  constructor(
    private router: Router,
    private quotesRepository: QuotesRepository,
    private billsRepository: BillsRepository,
    private bookOfBusinessService: BookOfBusinessService,
  ) {}

  ngOnInit(): void {
    this.loadQuotesYtd();
    this.loadGroupsManaged();
    this.loadActiveClients();
    this.loadAgentModeLink();
  }

  navigate(href: string): void {
    this.router.navigateByUrl(href);
  }

  private loadQuotesYtd(): void {
    const params = getHttpParams({ PageIndex: 0, PageSize: 10000, skipLoader: true });
    this.quotesRepository.getApplicationData(params).subscribe(res => {
      const yearStart = new Date(new Date().getFullYear(), 0, 1).getTime();
      const count = res.data.filter(q => q.startDate && new Date(q.startDate).getTime() >= yearStart).length;
      const ytd = this.stats.find(s => s.label === 'Quotes YTD');
      if (ytd) ytd.value = String(count);
    });
  }

  private loadGroupsManaged(): void {
    const params = getHttpParams({ PageIndex: 0, PageSize: 1, skipLoader: true });
    this.billsRepository.getBillsData(params).subscribe(res => {
      const groups = this.stats.find(s => s.label === 'Groups Managed');
      if (groups) groups.value = String(res.total);
    });
  }

  private loadAgentModeLink(): void {
    this.quotesRepository
      .getSharedLink()
      .pipe(take(1))
      .subscribe(link => {
        this.agentModeLink = link + '&isAgentMode=true';
      });
  }

  private loadActiveClients(): void {
    this.bookOfBusinessService.getBookOfBusiness().subscribe(data => {
      const count = data.filter(c => c.statusType !== 'Termed').length;
      const stat = this.stats.find(s => s.label === 'Total Active Clients');
      if (stat) stat.value = String(count);
    });
  }
}
